export default {
    lang: {
        name: 'First published year'
    }
}